<template>
  <div class="v-section-panel">
    <!-- セクションタイトル -->
    <p class="v-section-panel__title" v-if="$slots.title">
      <slot name="title"/>
    </p>

    <!-- セクション内容 -->
    <div v-if="$slots.content">
      <slot name="content"/>
    </div>

    <!-- 区切り線 -->
    <div v-if="useBreak">
      <p class="v-section-panel__break-line"/>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    useBreak: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style lang="stylus" scoped>
.v-section-panel
  &__title
    color rgb(120 112 112 / 1)
    font-weight bold
    margin-bottom 10px

  &__break-line
    margin-top 26px
    margin-bottom 32px
    border-bottom 1px dashed gray
</style>>
